import React, { Component } from 'react'
import { node, bool } from 'prop-types'
import { Helmet } from 'react-helmet'
import config from "../config";
import DefaultHeader from "./header/DefaultHeader";

class Layout extends Component {
  constructor (props) {
    super(props)
    this.state = { isClient: false }
  }

  componentDidMount () {
    this.setState({ isClient: true })
  }

  getClaritySnippet () {
    return <script>
      {`
             (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
             })(window, document, "clarity", "script", "${config.clarityId}");
            `}
    </script>
  }

  render () {
    const { children, noMeta } = this.props
    if (noMeta) {
      return (
        <div>
          <Helmet>
            <html lang='en' />
            <meta charset='utf-8' />
            <title>
              Rebrandly | Custom URL Shortener, Branded Link Management, API
            </title>
            <meta name='google-site-verification' content='4_wjl2_6-aIQRAzqg3lLPX9Sa78zxuJ_EbI_L-yOzoE' />
            <meta content='width=device-width, initial-scale=1' name='viewport' />
            <link href='images/rebrandly-webclip.png' rel='apple-touch-icon' />
            <link rel='stylesheet' href='https://use.typekit.net/waw8itp.css' />
            <script src='/js/signup-redirect.min.js' />
            <script>
              {`
              (function(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
              })(window, document, 'script', 'dataLayer', 'GTM-NZVWGS3');
          `}
            </script>
            <noscript>
              {`<iframe src="https://www.googletagmanager.com/ns?id=GTM-NZVWGS3" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
            </noscript>
            {this.getClaritySnippet()}
          </Helmet>
          <div id='mobile-nav' />
          <DefaultHeader />
          <div>
            {children}
          </div>
        </div>
      )
    }
    return (
      <div>
        <Helmet>
          <html lang='en' />
          <meta charset='utf-8' />
          <title>
            Rebrandly | Custom URL Shortener, Branded Link Management, API
          </title>
          <meta name='google-site-verification' content='4_wjl2_6-aIQRAzqg3lLPX9Sa78zxuJ_EbI_L-yOzoE' />
          <meta
            content='The perfect free URL shortener for transforming long, ugly links into nice, memorable and trackable short URLs. Use it to shorten links'
            name='description'
          />
          <meta
            content='Rebrandly | Custom URL Shortener, Branded Link Management, API'
            property='og:title'
          />
          <meta
            content='The perfect free URL shortener for transforming long, ugly links into nice, memorable and trackable short URLs. Use it to shorten links'
            property='og:description'
          />
          <meta content='/open-graph.png' property='og:image' />
          <meta content='summary' name='twitter:card' />
          <meta content='width=device-width, initial-scale=1' name='viewport' />
          <link href='images/rebrandly-webclip.png' rel='apple-touch-icon' />
          <link rel='stylesheet' href='https://use.typekit.net/waw8itp.css' />
          <script src='/js/signup-redirect.min.js' />
          <script>
            {`
              (function(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
              })(window, document, 'script', 'dataLayer', 'GTM-NZVWGS3');
          `}
          </script>
          <noscript>
            {`<iframe src="https://www.googletagmanager.com/ns?id=GTM-NZVWGS3" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
          </noscript>
          {this.getClaritySnippet()}
        </Helmet>
        <div id='mobile-nav' />
        <DefaultHeader />
        <div>
          {children}
        </div>
      </div>
    )
  }
}

Layout.propTypes = {
  children: node,
  noMeta: bool
}

export default Layout
